'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

var _reactRouter = require('react-router');

var _preludeExtension = require('prelude-extension');

var _users = require('redux/modules/users');

var _reactBootstrap = require('react-bootstrap');

var _validation = require('utils/validation');

var _userSmall = require('../../assets/images/user-small.png');

var _userSmall2 = _interopRequireDefault(_userSmall);

var _Creatable = require('react-select/lib/Creatable');

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserRoleSelector = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { search: _users.search, invite: _users.invite }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(UserRoleSelector, _Component);

  function UserRoleSelector() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserRoleSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserRoleSelector.__proto__ || (0, _getPrototypeOf2.default)(UserRoleSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ajax: null,
      invalidRole: false,
      invalidUser: false,
      loading: false,
      selectedUser: null,
      selectedRole: 'no_role',
      options: [],
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UserRoleSelector, [{
    key: 'onSearchChange',
    value: function onSearchChange(input) {
      var _this2 = this;

      var query = input.trim();
      var ajax = this.state.ajax;


      if (ajax) {
        clearTimeout(ajax);
      }

      this.setState({
        ajax: setTimeout(function () {
          _this2.loadUsers(query);
        }, 250),
        loading: query.length > 2,
        invalidUser: false
      });
    }
  }, {
    key: 'toggleOpen',
    value: function toggleOpen() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: 'changeRoleExisting',
    value: function changeRoleExisting(userId, event) {
      this.props.editUser(userId, event.target.value);
    }
  }, {
    key: 'changeRole',
    value: function changeRole(event) {
      this.setState({
        invalidRole: false,
        selectedRole: event.target.value
      });
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(event) {
      this.props.removeUser(parseInt(event.target.dataset.id, 10));
      event.stopPropagation();
    }
  }, {
    key: 'handleAdd',
    value: function handleAdd() {
      var _this3 = this;

      var invite = this.props.invite; // eslint-disable-line no-shadow

      var _state = this.state,
          selectedRole = _state.selectedRole,
          selectedUser = _state.selectedUser;
      var _state2 = this.state,
          invalidRole = _state2.invalidRole,
          invalidUser = _state2.invalidUser;

      if (selectedUser.__isNew__) {
        selectedUser.name = selectedUser.label;
        selectedUser.email = selectedUser.label;
      }
      if (selectedUser <= 0 || selectedRole === 'no_role') {
        if (selectedUser <= 0) {
          invalidUser = true;
        } else {
          invalidUser = false;
        }

        if (selectedRole === 'no_role') {
          invalidRole = true;
        } else {
          invalidRole = false;
        }

        this.setState({
          invalidRole: invalidRole,
          invalidUser: invalidUser,
          selectedRole: selectedRole,
          selectedUser: selectedUser
        });

        return;
      }

      var query = {
        email: selectedUser.email,
        name: selectedUser.email,
        role: selectedRole
      };

      if (this.props.organizationId) {
        query.organization_id = this.props.organizationId;
      }

      if (this.props.calendarId) {
        query.calendar_id = this.props.calendarId;
      }

      invite(query).then(function (res) {
        if (!res || res.type !== _users.INVITE_SUCCESS) {
          throw res.error;
        }

        var user = (0, _extends3.default)({
          id: selectedUser.id
        }, query, res.result);
        _this3.props.addUser(user, _this3.state.selectedRole);
        _this3.setState({
          invalidRole: false,
          invalidUser: false,
          selectedUser: null
        });
      }).catch(function (err) {
        throw err;
      });
    }
  }, {
    key: 'loadUsers',
    value: function loadUsers(query, callback) {
      var _this4 = this;

      if (query.length > 2) {
        this.setState({
          ajax: null,
          loading: true
        }, function () {
          _this4.props.search(query).then(function (users) {
            var existingUserIds = _this4.props.except;
            var data = users.result.data;


            var usersRendered = data.map(function (user) {
              var label = user.name + ' (' + user.email + ')';
              if (existingUserIds.indexOf(user.id) > -1) {
                return null;
              }
              return (0, _extends3.default)({}, user, {
                label: label,
                labelPartitions: (0, _preludeExtension.partitionString)((0, _unidecode2.default)(label).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase()),
                value: user.id
              });
            }).filter(function (ur) {
              return !!ur;
            });

            _this4.setState({
              options: usersRendered,
              loading: false
            }, callback);
          });
        });
      } else if (query.length <= 2) {
        this.setState({
          options: []
        }, callback);
      }
    }
  }, {
    key: 'validateUserInput',
    value: function validateUserInput(query) {
      // return null if it's not an email or if it's already in the list
      var input = query.trim();
      if (!query || (0, _validation.email)(input) === 'Invalid email address') {
        return false;
      }
      return true;
    }
  }, {
    key: 'changeUser',
    value: function changeUser(selectedUser) {
      if (selectedUser.__isNew__) {
        var newUser = {
          name: selectedUser.value,
          email: selectedUser.value
        };

        this.setState({
          invalidUser: !selectedUser,
          selectedUser: newUser
        });
      }
      this.setState({
        invalidUser: !selectedUser,
        selectedUser: selectedUser
      });
    }
  }, {
    key: 'renderNoResults',
    value: function renderNoResults(value) {
      var polyglot = this.props.polyglot;
      var loading = this.state.loading;


      if (loading) {
        return _react2.default.createElement(
          'div',
          { className: 'no-results-found', style: { fontSize: 13 } },
          polyglot.t('events.loading')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'no-results-found', style: { fontSize: 13 } },
        value.length <= 2 ? polyglot.t('simpleSelect.typeSome') : polyglot.t('simpleSelect.noResults')
      );
    }
  }, {
    key: 'renderUserRow',
    value: function renderUserRow(user) {
      var polyglot = this.props.polyglot;


      return _react2.default.createElement(
        'div',
        { className: 'user-role-row', key: user.id },
        _react2.default.createElement(
          'div',
          { className: 'col-sm-7 text-left user-identity' },
          _react2.default.createElement(
            'div',
            { className: 'media' },
            _react2.default.createElement(
              'div',
              { className: 'media-left media-middle' },
              _react2.default.createElement('img', { className: 'media-object', src: user.avatar && user.avatar.sizes && user.avatar.sizes.small || _userSmall2.default, width: '36', height: '36', alt: 'avatar' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'media-body' },
              _react2.default.createElement(
                'h4',
                { className: 'media-heading' },
                user.name
              ),
              _react2.default.createElement(
                'small',
                null,
                user.email
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-sm-' + (user.source ? '5' : '3') + ' user-role' },
          user.source ? polyglot.t('roles.' + user.role) : _react2.default.createElement(
            'label',
            { className: 'select-wrapper' },
            _react2.default.createElement(
              'select',
              { className: 'form-control', value: user.role, onChange: this.changeRoleExisting.bind(this, user.id) },
              _react2.default.createElement(
                'option',
                { value: 'no_role', disabled: true },
                polyglot.t('userRoleSelector.role')
              ),
              _react2.default.createElement(
                'option',
                { value: 'guest' },
                polyglot.t('roles.guest')
              ),
              _react2.default.createElement(
                'option',
                { value: 'contributor' },
                this.props.polyglot.t('roles.contributor')
              ),
              _react2.default.createElement(
                'option',
                { value: 'editor' },
                this.props.polyglot.t('roles.editor')
              ),
              _react2.default.createElement(
                'option',
                { value: 'admin' },
                this.props.polyglot.t('roles.admin')
              )
            )
          ),
          user.source && _react2.default.createElement(
            'span',
            null,
            ' ',
            this.props.polyglot.t('userRoleSelector.on'),
            ' ',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/organizations/' + user.source.id },
              user.source.name
            )
          )
        ),
        !user.source && _react2.default.createElement('a', { href: '#', className: 'col-sm-2 row-action result-unlink', 'data-id': user.id, onClick: this.handleRemove.bind(this) })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          users = _props.users,
          inheritedUsers = _props.inheritedUsers,
          polyglot = _props.polyglot;
      var _state3 = this.state,
          invalidRole = _state3.invalidRole,
          invalidUser = _state3.invalidUser,
          selectedUser = _state3.selectedUser,
          open = _state3.open,
          options = _state3.options,
          loading = _state3.loading;

      var localeSortByName = function localeSortByName(userA, userB) {
        return userA.name.toLowerCase().localeCompare(userB.name.toLowerCase(), 'fr');
      };

      var usersList = _react2.default.createElement(
        'div',
        { className: 'users-list result' },
        open && inheritedUsers.sort(localeSortByName).map(this.renderUserRow.bind(this)),
        users.sort(localeSortByName).map(this.renderUserRow.bind(this))
      );

      var newUserRoleWidgets = _react2.default.createElement(
        'div',
        { className: 'new-user-role-widget' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-7' },
            _react2.default.createElement(_Creatable2.default, {
              className: 'react-select',
              classNamePrefix: 'react-select',
              ref: 'simpleSelectUser',
              onInputChange: this.onSearchChange.bind(this),
              onChange: this.changeUser.bind(this),
              placeholder: polyglot.t('userRoleSelector.selectPlaceholder'),
              noOptionsMessage: this.renderNoResults.bind(this),
              options: options,
              value: selectedUser,
              isValidNewOption: this.validateUserInput.bind(this),
              isLoading: loading,
              allowCreateWhileLoading: false,
              formatCreateLabel: function formatCreateLabel(label) {
                return polyglot.t('userRoleSelector.addUser') + ' ' + label + ' ... ';
              }
            }),
            invalidUser && _react2.default.createElement(
              _reactBootstrap.Tooltip,
              { id: 'user-error', className: 'in', placement: 'bottom' },
              polyglot.t('userRoleSelector.selectUser')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-3 user-role' },
            _react2.default.createElement(
              'label',
              { className: 'select-wrapper' },
              _react2.default.createElement(
                'select',
                { className: 'form-control', value: this.state.selectedRole, onChange: this.changeRole.bind(this) },
                _react2.default.createElement(
                  'option',
                  { value: 'no_role', disabled: true },
                  polyglot.t('userRoleSelector.role')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'guest' },
                  polyglot.t('roles.guest')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'contributor' },
                  polyglot.t('roles.contributor')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'editor' },
                  polyglot.t('roles.editor')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'admin' },
                  polyglot.t('roles.admin')
                )
              )
            ),
            invalidRole && _react2.default.createElement(
              _reactBootstrap.Tooltip,
              { id: 'role-error', className: 'in', placement: 'bottom' },
              polyglot.t('userRoleSelector.selectRole')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-2 row-action' },
            _react2.default.createElement(
              'button',
              { className: 'btn btn-primary btn-sm', onClick: this.handleAdd.bind(this) },
              polyglot.t('userRoleSelector.add')
            )
          )
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'user-role-selector' },
        _react2.default.createElement(
          'h2',
          null,
          polyglot.t('userRoleSelector.members')
        ),
        inheritedUsers.length > 0 && _react2.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'link', bsSize: 'small', className: 'toggle-button', onClick: this.toggleOpen.bind(this) },
          open ? polyglot.t('userRoleSelector.hideInheritedRights') : polyglot.t('userRoleSelector.showInheritedRights')
        ),
        newUserRoleWidgets,
        usersList
      );
    }
  }]);
  return UserRoleSelector;
}(_react.Component), _class2.propTypes = {
  addUser: _propTypes2.default.func,
  editUser: _propTypes2.default.func,
  errors: _propTypes2.default.any,
  except: _propTypes2.default.array,
  inheritedUsers: _propTypes2.default.array,
  removeUser: _propTypes2.default.func,
  search: _propTypes2.default.func.isRequired,
  invite: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  users: _propTypes2.default.array.isRequired,
  organizationId: _propTypes2.default.number,
  calendarId: _propTypes2.default.number
}, _class2.defaultProps = {
  addUser: function addUser() {},
  except: [],
  inheritedUsers: []
}, _temp2)) || _class);
exports.default = UserRoleSelector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/UserRoleSelector.js
// module id = 2226
// module chunks = 0